import React from 'react';
import { STARTUP_NAME } from '../config/constants';

function Usname() {
    return <div style={{ display: 'flex', fontSize: 35, width: '100%', placeContent: 'center', fontFamily: 'Marck Script' }}>{STARTUP_NAME}</div>
}

export default Usname